import React from 'react'
import { connect } from 'react-redux'

let ChangeWeek = ({ tribalCounter }) => {
  return (
    <span className="mdl-chip mdl-chip--contact">
        <span className="mdl-chip__contact mdl-color--teal mdl-color-text--white">{tribalCounter}</span>
        <span className="mdl-chip__text">Torches Snuffed</span>
    </span>
  )
}

const mapStateToProps = (state, ownProps) => ({
  tribalCounter: state.standings.activeTribalNumber
})

ChangeWeek = connect(
  mapStateToProps
)(ChangeWeek)

export default ChangeWeek
